import { render } from "./vuetable-pagination.vue?vue&type=template&id=ed9013be&lang=pug"
import script from "./vuetable-pagination.vue?vue&type=script&lang=js"
export * from "./vuetable-pagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__